import { useEffect, useState } from "react";
import api from "../../../utills/api";

const useDashboardData = () => {
  const [data, setData] = useState({
    channels: [],
    mappings: [],
    inventory: [],
    inventoryLogs: [],
    rates: [],
    rateLogs: [],
    restrictions: [],
    restrictionLogs: [],
    syncDashboard: {},
    syncLogs: [],
    bookingLogs: [],
  });

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const [
        channels,
        mappings,
        inventory,
        inventoryLogs,
        rates,
        rateLogs,
        restrictions,
        restrictionLogs,
        syncDashboard,
        syncLogs,
        bookingLogs,
      ] = await Promise.all([
        api.get("/channels"),
        api.get("/room-mappings"),
        api.get(
          "/inventory/calendar?startDate=2026-06-13&endDate=2026-06-19"
        ),
        api.get("/inventory/logs"),
        api.get(
          "/rates/calendar?startDate=2026-06-13&endDate=2026-06-19"
        ),
        api.get("/rates/logs"),
        api.get("/restrictions"),
        api.get("/restrictions/logs"),
        api.get("/sync-logs/dashboard"),
        api.get("/sync-logs"),
        api.get("/bookings/logs"),
      ]);

      console.log("CHANNELS", channels.data);
      console.log("MAPPINGS", mappings.data);
      console.log("INVENTORY", inventory.data);
      console.log("INVENTORY LOGS", inventoryLogs.data);
      console.log("RATES", rates.data);
      console.log("RATE LOGS", rateLogs.data);
      console.log("RESTRICTIONS", restrictions.data);
      console.log("RESTRICTION LOGS", restrictionLogs.data);
      console.log("SYNC DASHBOARD", syncDashboard.data);
      console.log("SYNC LOGS", syncLogs.data);
      console.log("BOOKING LOGS", bookingLogs.data);

      setData({
        // CHANNELS
        channels:
          channels?.data?.connections || [],

        // ROOM MAPPINGS
        mappings:
          mappings?.data?.mappings || [],

        // INVENTORY CALENDAR
        inventory:
          inventory?.data?.data || [],

        // INVENTORY LOGS
        inventoryLogs:
          inventoryLogs?.data?.logs || [],

        // RATES
        rates:
          rates?.data?.data || [],

        // RATE LOGS
        rateLogs:
          rateLogs?.data?.logs || [],

        // RESTRICTIONS
        restrictions:
          restrictions?.data?.data || [],

        // RESTRICTION LOGS
        restrictionLogs:
          restrictionLogs?.data?.logs || [],

        // DASHBOARD
        syncDashboard:
          syncDashboard?.data?.dashboard || {},

        // SYNC LOGS
        syncLogs:
          syncLogs?.data?.logs || [],

        // BOOKINGS
        bookingLogs:
          bookingLogs?.data?.bookingLogs || [],
      });

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    refresh: loadData,
  };
};

export default useDashboardData;